export default __webpack_public_path__ + "static/media/640_blank-fr-mobile.855333c3.png";